import WrappedPaypalButton from './WrappedPaypalButton';
import WrappedPaypalButtonDesktop from './WrappedPaypalButtonDesktop';
import useMobile from 'hooks/useMobile';

export default (props) => {
  const { isMobile } = useMobile();

  if (isMobile) {
    return <WrappedPaypalButton {...props} />;
  } else {
    return <WrappedPaypalButtonDesktop {...props} />;
  }
};
